import React, { FunctionComponent } from 'react';
import classNames from 'classnames';
import { Button } from '../../Input/Button/Button';
import { useAppDispatch } from '../../../redux/store';
import { LinkButton } from '../../Input/Button/LinkButton';
import { logout } from '../../../utils/redux';
import styles from '../styles.module.scss';

export const DealerLaunchComplete: FunctionComponent = () => {
  const dispatch = useAppDispatch();

  return (
    <div className={classNames(styles.stepContainer, styles.reviewStep)}>
      <div className={styles.stepTitle}>
        Congratulations, you&apos;ve submitted your Setup Details!
      </div>
      <div className={styles.stepCard}>
        <h1>Great Work, we&apos;ve received your Setup Details!</h1>
        <p>
          We can&apos;t wait to launch with you and start optimizing your sales
          experience. Please reach out if you have any questions. In the
          meantime, here are some FAQs you may find helpful.
        </p>
        <br />
        <h2>What happens next?</h2>
        <p>
          If you haven&apos;t already, you&apos;ll receive an email from our
          team to check in and make sure that we&apos;ve got everything setup
          perfectly to get your dealership up and running with Upstart Auto
          Retail as soon as possible.
        </p>
        <br />
        <h2>How long will it take to launch?</h2>
        <p>
          Once you have submitted all of your setup details it usually takes
          around two business days for us to integrate with your systems. The
          average launch timeline is around 2-3 days after we receive all of
          your setup details.
        </p>
        <br />
        <h2>How do I change my setup details after submission?</h2>
        <p>
          Once your details are submit we begin integrating with your systems
          right away. If you notice anything that is incorrect please contact us
          at{' '}
          <LinkButton
            to="mailto:dealersetup@upstart.com"
            variant="minimal"
            rawLink
          >
            dealersetup@upstart.com
          </LinkButton>{' '}
          to correct the information provided.
        </p>
        <br />
        <div>
          <div className="spacer" />
          <Button
            label="Logout from Set Up"
            variant="primary"
            onClick={() => logout(dispatch)}
          />
          <div className="spacer" />
        </div>
      </div>
    </div>
  );
};
